// Import dependencies
import ReactDOM from 'react-dom';
import React from 'react';

// Components
import Calendar from './components/Calendar';

const renderCalendarSidebar = () => {
  const App = () => <Calendar />;

  ReactDOM.render(<App />, document.getElementById('calendar-content'));
};

export default renderCalendarSidebar;
